import React from 'react';
// styles
import styles from './PageWrapper.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const PageWrapper = ({ children, centered, className, ...props }) => (
  <div
    className={cx('wrapper', className, { centered }, 'animated fadeIn')}
    {...props}
  >
    {children}
  </div>
);

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/PageWrapper/PageWrapper.jsx